import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withErrorBoundary from "components/ui/withErrorBoundaries";
import { ButtonHTMLAttributes, FC } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  icon?: any;
  iconclassname?: string;
  goButton?: boolean;
}

const Button: FC<ButtonProps> = ({ className = 'btn btn-primary', ...props }) => {
  return (
    <button {...props} className={className + (props.disabled ? ' btn-disabled' : '')}>
      {props.icon && <FontAwesomeIcon icon={props.icon} className={props.iconclassname} />}{' '}
      {props.title}
    </button>
  );
};

export default withErrorBoundary(Button, 'Button');
